import TopPlayedChart from "./TopPlayedChart.js";
export default TopPlayedChart;